import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin } from 'rxjs';
import { UserService } from "./core/user/user.service";

// ✅ Nuevo enfoque con ResolveFn (recomendado en Angular 15+)
export const initialDataResolver: ResolveFn<any> = () => {
    const userService = inject(UserService);
    const navigationService = inject(NavigationService);
    const messagesService = inject(MessagesService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    return forkJoin([
        userService.get(),
        navigationService.get(),
        messagesService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
    ]);
};
